<template>
  <div class="pagelist">
    <div class="pagelist_layer" v-for="(item, index) in data" :key="index">
      <div class="layer_item">
        <div class="item_top">
          <div class="top_content">
            <img :src="item?.cover?.url" width="170px" alt="" />
          </div>
          <div class="top_mask">
            <div class="mask" v-if="item?.qrcode_url">
              <div class="mask_img">
                <img :src="item.qrcode_url" width="120px" alt="" />
              </div>
              <div class="mask_txt">扫描二维码预览</div>
            </div>
            <div class="mask" v-else>
              暂无二维码
            </div>
          </div>
        </div>
        <div class="item_bottom" style="padding-top: 10px;">
          <div>
			<div  class="flex"
            style="margin-top: 10px;margin-bottom: 5px; justify-content: space-between; align-items: center">
				<div class="bottom_tip" v-if="item.page_type == '10'">商城首页</div>
				<div class="bottom_tip bottom_tip_user" v-else-if="item.page_type == '30'">个人中心</div>
				<div class="bottom_tip bottom_tip_details" v-else-if="item.page_type == '40'">商品详情</div>
				<div class="bottom_tip bottom_tip_diy" v-else>自定义页面</div>
				<div class="bottom_titles">{{item.page_name}}</div>
			</div>
		  <div class="flex"
            style="justify-content: space-between; align-items: center">
		  
            <div>
              
              <div class="bottom_box">
                <div class="bottom_box_time">时间:{{item.updated_at}}</div>
              </div>
            </div>
			
            <div v-if="item.page_type == 10" class="bottom_box_btn"  style="cursor: pointer;width: 50px;" @click="
                $router.push({
                  // 推送方法
                  path: '/weishop/store/page_add_full', //导航的路径
                  query: {
                    id: item.page_id,
                    data:item,
                    title: '新增',
					crumbs:[
						{name:'店铺管理',path:'/weishop/store/list',query:''},
						{name:item.page_name+'编辑',path:'',query:''}
					]
                  }
                })
              ">编辑</div>
			<div v-if="item.page_type == 20" class="bottom_box_btn"  style="cursor: pointer;width: 50px;" @click="
			    $router.push({
			      // 推送方法
			      path: '/weishop/store/page_add_diy', //导航的路径
			      query: {
			        id: item.page_id,
			        data:item,
			        title: '新增',
					crumbs:[
						{name:'店铺管理',path:'/weishop/store/list',query:''},
						{name:item.page_name+'编辑',path:'',query:''}
					]
			      }
			    })
			  ">编辑</div>
			<!-- <div v-else class="bottom_box_btn"  style="cursor: pointer;width: 50px;" @click="
			    $router.push({
			      // 推送方法
			      path: '/weishop/store/page_add_full', //导航的路径
			      query: {
			        id: item.page_id,
			        data:item,
			        title: '新增',
					crumbs:[
						{name:'店铺管理',path:'/weishop/store/list',query:''},
						{name:item.page_name+'编辑',path:'',query:''}
					]
			      }
			    })
			  ">编辑</div> -->
          </div>
		  </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PageList",
  props: {
    data: [],
  },
  data() {
    return {};
  },
  methods: {
  },
};
</script>
<style lang="less" scoped>
.pagelist {
  display: flex;
  flex-wrap: wrap;
  &_layer {
    // width: 25%;
    display: flex;
    align-items: center;
    padding: 15px;
    .layer_item {
      padding: 20px;
      width: 252px;
      border: 1px solid #e9edef;
      border-radius: 20px;
      display: flex;
      align-items: center;
      flex-direction: column;
      position: relative;

      .item_top {
        border-radius: 14px;
        background: white;
        height: 250px;
        .top_mask {
          position: absolute;
          top: 0;
          right: 0;
          background: rgba(0, 0, 0, 0.5);
          width: 250px;
          height: 310px;
          border-top-right-radius: 20px;
          border-top-left-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          display: none;
          .mask {
            width: 140px;
            background: #ffff;
            border-radius: 10px;
            padding: 10px 0px;
            display: flex;
            flex-direction: column;
            align-items: center;
            &_txt {
              color: #63719f;
              font-size: 12px;
              text-align: center;
            }
          }
        }
      }

      &:hover .top_mask {
        display: flex;
      }
      .item_bottom {
        margin-top: 30px;
        width: 250px;
        padding: 0 12px;
		background-color: #fff;
        .bottom_tip {
          background: #006AFF1A;
          color: #006aff;
          border-radius: 2px;
          height: 26px;
          width: 68px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .bottom_tip_diy {
          background: #FF88001A;
          color: #FF8800;
        }
		.bottom_tip_user {
		  background: #19be6b1A;
		  color: #19be6b;
		}
		.bottom_tip_details {
		  background: #04af021A;
		  color:#04af02;
		}
        .bottom_titles {
          font-size: 16px;
          font-weight: bold;
        }
        .bottom_box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          &_time {
            color: #63719f;
          }
          &_btn {
            width: 84px;
            height: 30px;
            border-radius: 2px;
            line-height: 30px;
            text-align: center;
            color: #ffff;
            font-size: 14px;
            // background: #006aff;
			border:1px solid  #006aff;
			color:#006aff ;
			&:hover{
				color: #fff;
				background: #006aff;
			}
          }
        }
      }
    }
  }
}
</style>
